export const TIER_ORDER = { basic: 0, pro: 1, elite: 2 };

export const PAGE_MIN_TIER = {
  '/': 'basic',
  '/schedule': 'basic',
  '/practice': 'basic',
  '/players': 'basic',
  '/whiteboard': 'basic',
  '/stats': 'basic',
  '/communication': 'basic',
  '/admin/analytics': 'basic',
  '/settings': 'basic',
  '/reports': 'pro',
  '/coaching-communication': 'elite',
  '/contacts': 'elite',
  '/automated-messages': 'elite',
  '/social-media': 'elite',
  '/videos': 'elite',
  '/photos': 'elite'
};

export const TIER_LABELS = { basic: 'Basic', pro: 'Pro', elite: 'Elite' };

export const hasAccess = (tier, path) => {
  const userLevel = TIER_ORDER[tier] ?? 0;
  const required = TIER_ORDER[PAGE_MIN_TIER[path] ?? 'basic'] ?? 0;
  return userLevel >= required;
};

export const requiredTier = (path) => PAGE_MIN_TIER[path] ?? 'basic';
